module.exports = __webpack_public_path__ + "static/media/coinIco-01.63c489d6.png";